import { SafeUrl } from "@angular/platform-browser";
import { PermanentOperation } from '@app/models';

export class PermanentOperationItem {
    id: number;   
    name: string;  
    logo?: string|SafeUrl;  

    static FromPermanentOperation(o: PermanentOperation): PermanentOperationItem{
        let permanentOperationItem = new PermanentOperationItem();
        permanentOperationItem.id = o.id;
        permanentOperationItem.name = o.title;
        permanentOperationItem.logo = o.logo;
        return permanentOperationItem;
    }      
}

